<script lang="ts">
	import { onMount } from "svelte";

	import Introduction from "./Introduction.svelte";
	import InspirationAndBackground from "./InspirationAndBackground.svelte";
	
	import DashboardDyslexia from "./DashboardDyslexia.svelte";
	import About from "./About.svelte";

	import GeneratePieceOfArt from "../common/GeneratePieceOfArt.svelte";

	export let hash: string;

	let width: number;
	onMount(async () => {
		const artSection = document.querySelector("#artSection");
		width = artSection.clientWidth;
	});
</script>

<main class="container">
	<section>
		<Introduction />
	</section>

	<section>
		<InspirationAndBackground />
	</section>

	<section id="artSection">
		<h1>A random final Dashboard Dyslexia</h1>
		<DashboardDyslexia {width} height={width} {hash} />
	</section>

	<GeneratePieceOfArt {hash}/>

	<section>
		<h1>About Dashboard Dyslexia and Pandelune</h1>
		<About />
	</section>

	<footer>
		<span id="copyright"
			>&copy; Copyright 2024, Pandelune. All the content is under copyright,
			including the source code of "Dashboard Dyslexia".</span
		>
	</footer>
</main>